"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var browser_logs_1 = require("@datadog/browser-logs");
var DD_CLIENT_TOKEN = "pub09b4af4dce4e5ca0f9953b99742fae3e";
var LOG_LEVEL_MAPPER = {
    all: Number.MIN_SAFE_INTEGER,
    debug: 10,
    info: 20,
    error: 100,
    none: Number.MAX_SAFE_INTEGER,
};
var LOG_COLOR_MAPPER = {
    info: ["color:blue", "color:grey"],
    debug: ["color:grey", "color:grey"],
    error: ["color:red", "color:red"],
};
var Logger = /** @class */ (function () {
    function Logger(context, options) {
        if (context === void 0) { context = {}; }
        if (options === void 0) { options = { sendLogs: false, minLogLevel: "error" }; }
        this.prefix = "SCORM WRAPPER";
        this.minLogLevel = options.minLogLevel;
        this.sendLogs = options.sendLogs;
        this.sendLogs &&
            browser_logs_1.datadogLogs.init({
                clientToken: DD_CLIENT_TOKEN,
                site: "datadoghq.eu",
                env: context.env,
                service: ["wrapper", context.service].filter(Boolean).join(":"),
                forwardErrorsToLogs: true,
                sessionSampleRate: 100,
            });
    }
    Logger.prototype.shouldLog = function (level) {
        return LOG_LEVEL_MAPPER[level] >= LOG_LEVEL_MAPPER[this.minLogLevel];
    };
    Logger.prototype.log = function (level, msg) {
        if (!this.shouldLog(level))
            return;
        var formattedMsg = "%c[".concat(this.prefix, " - ").concat(level.toUpperCase(), "]: %c").concat(msg);
        console[level].apply(console, __spreadArray([formattedMsg], LOG_COLOR_MAPPER[level], false));
        if (this.sendLogs)
            browser_logs_1.datadogLogs.logger[level](msg);
    };
    Logger.prototype.error = function (message) {
        this.log("error", message);
    };
    Logger.prototype.info = function (message) {
        this.log("info", message);
    };
    Logger.prototype.debug = function (message) {
        this.log("debug", message);
    };
    return Logger;
}());
exports.default = Logger;
//# sourceMappingURL=logger.js.map